<template>
  <div class='EnbNave01'>
    <component :is="!Prefes.componentModel01Nave ? 'EnbNave0101' : Prefes.componentModel01Nave.name"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EnbNave0101 from './EnbNave0101'
import EnbNave0102 from './EnbNave0102'
export default {
  name: 'EnbNave01',
  components: { EnbNave0101, EnbNave0102 },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.EnbNave01 {
  width: 100%;
}
</style>